import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class MediaContentToggle extends UcoastEl {
	static htmlSelector = 'media-content-toggle'
	contentToggles: NodeListOf<HTMLElement>
	disclosureItems: NodeListOf<HTMLElement>
	detailsItems: NodeListOf<HTMLDetailsElement>
	//mediaItems: NodeListOf<HTMLElement>
	currentIndex: number = 0
	openFirstItem: boolean = true
	constructor() {
		super()
		//this.mediaItems = q.rl('[data-uc-media-content-toggle-media-item]', this)
		this.contentToggles = q.rl('[data-uc-media-content-toggle-toggle-item]', this)
		this.disclosureItems = q.rl('[data-uc-media-content-toggle-disclosure-item]', this)
		this.detailsItems = q.rl('[data-uc-media-content-toggle-details-item]', this)
		if (this.hasAttribute('data-uc-media-content-toggle-default-closed')) {
			this.openFirstItem = false
			this.currentIndex = -1
		}

	}

	openFromEvent() {
		this.open()
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		//document.removeEventListener('DOMContentLoaded', this.openFromEvent.bind(this))
		window.removeEventListener('load', this.openFromEvent.bind(this))
	}

	override connectedCallback() {
		super.connectedCallback()
		if (this.openFirstItem) {
			window.addEventListener('load', this.openFromEvent.bind(this))
		}

		this.contentToggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault()
				const index = parseInt(q.ra(toggle, 'data-uc-media-content-toggle-toggle-item'))
				if (index === this.currentIndex) {
					this.setCurrentIndex(-1)
				} else {
					this.setCurrentIndex(index)
				}

				this.open()
			})
		})
	}
	setCurrentIndex(index: number) {
		this.currentIndex = index
	}
	open() {
    window.TsDOM.removeTrapFocus()
		for (let i = 0; i < this.disclosureItems.length; i++) {
			//const mediaItem = this.mediaItems[i]
			const contentToggle = this.contentToggles[i]
			const disclosureItem = this.disclosureItems[i]
			const detailsItem = this.detailsItems[i]
			if (i === this.currentIndex) {
				disclosureItem.style.maxHeight = '0px'
				detailsItem.setAttribute('open', '')
				detailsItem.classList.add('active')
				window.setTimeout(() => {
					disclosureItem.style.maxHeight = `${disclosureItem.scrollHeight}px`
				}, 1)
				//mediaItem.classList.add('active')
				contentToggle.classList.add('active')
				//trapFocus(mediaItem)
        window.TsDOM.trapFocus(detailsItem)
			} else {
				disclosureItem.style.maxHeight = '0px'
				contentToggle.classList.remove('active')
				detailsItem.classList.remove('active')
				//mediaItem.classList.remove('active')
				window.setTimeout(() => {
					detailsItem.removeAttribute('open')
				}, 301)
			}
		}
	}
}
